// tslint:disable
/**
 * Course API
 * Used for: - Manage courses - Manage course info - Manage students - Learning control 
 *
 * The version of the OpenAPI document: 2.6.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Contractor } from './contractor';
import { StudentAllOf } from './student-all-of';
import { StudentAllOf1 } from './student-all-of1';
import { StudentCreate } from './student-create';
import { User } from './user';

/**
 * 
 * @export
 * @interface Student
 */
export interface Student {
    /**
     * 
     * @type {string}
     * @memberof Student
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Student
     */
    companyId: string;
    /**
     * 
     * @type {string}
     * @memberof Student
     */
    companyTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof Student
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof Student
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof Student
     */
    middleName?: string;
    /**
     * 
     * @type {string}
     * @memberof Student
     */
    fullName?: string;
    /**
     * 
     * @type {string}
     * @memberof Student
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof Student
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof Student
     */
    gender?: StudentGenderEnum;
    /**
     * 
     * @type {Date}
     * @memberof Student
     */
    birthday?: Date;
    /**
     * Additional metadata
     * @type {object}
     * @memberof Student
     */
    metadata?: object;
    /**
     * 
     * @type {string}
     * @memberof Student
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof Student
     */
    photoId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Student
     */
    contractorIds?: Array<string>;
    /**
     * 
     * @type {User}
     * @memberof Student
     */
    user?: User;
    /**
     * 
     * @type {Array<Contractor>}
     * @memberof Student
     */
    contractors?: Array<Contractor>;
    /**
     * 
     * @type {string}
     * @memberof Student
     */
    photoUrl?: string;
    /**
     * 
     * @type {Date}
     * @memberof Student
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Student
     */
    updatedAt: Date;
}

/**
    * @export
    * @enum {string}
    */
export enum StudentGenderEnum {
    Male = 'male',
    Female = 'female'
}



